var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteFriends(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.158,
    height: 20.158,
    viewBox: "0 0 20.158 20.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "vuesax/linear/profile-2user"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.864 7.45a1.527 1.527 0 0 0-.277 0 3.733 3.733 0 1 1 .277 0z",
    transform: "translate(3.83 1.68)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      stroke: "#1bc47d",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M.109 0a2.938 2.938 0 0 1 2.94 2.94A2.944 2.944 0 0 1 .218 5.879a.949.949 0 0 0-.218 0",
    transform: "translate(13.674 3.36)",
    style: {
      stroke: "#8c8d99",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M1.524 1.153c-2.033 1.361-2.033 3.578 0 4.93a8.2 8.2 0 0 0 8.408 0c2.033-1.361 2.033-3.578 0-4.93a8.241 8.241 0 0 0-8.408 0z",
    transform: "translate(1.97 11.077)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      stroke: "#1bc47d",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M0 5.04a4.063 4.063 0 0 0 1.646-.731 2.127 2.127 0 0 0 0-3.586A4.177 4.177 0 0 0 .025 0",
    transform: "translate(15.404 11.759)",
    style: {
      stroke: "#8c8d99",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px",
      fill: "none"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteFriends);
export default __webpack_public_path__ + "static/media/invite-friends.e734174735457c077d83beae885c1df3.svg";
export { ForwardRef as ReactComponent };